import styled, { css } from 'styled-components'
import { Box } from '../UI/Box'
import { Span } from './Typeography'

type ToggleButton = {
  name: string
  onClick: () => void
  isActive: boolean
  disabled?: boolean
}

export default function Toggler({ buttons }: { buttons: ToggleButton[] }) {
  return (
    <Container>
      {buttons.map(({ name, onClick, isActive, disabled }) => (
        <ToggleButton
          key={name}
          onClick={onClick}
          isActive={isActive}
          disabled={disabled}
          c
          as="button" // hack to get the box to respect disabled tag
        >
          <Span fw={isActive ? 'semibold' : 'regular'}>{name}</Span>
        </ToggleButton>
      ))}
    </Container>
  )
}

const Container = styled(Box)`
  border-radius: var(--units-44, 44px);
  border: 1px solid var(--stroke-tertiary);
  background: var(--surface-primary, #080808);
  display: flex;
  padding: 4px;
  align-items: flex-start;
  flex: 1 0 0;
`

const ToggleButton = styled(Box) <{ isActive: boolean }>`
  padding: var(--units-8, 8px) 24px;
  flex: 1 0 0;
  align-self: stretch;
  min-width: max-content;
  :disabled {
    cursor: not-allowed;
  }
  ${({ isActive }) =>
    isActive
      ? css`
          border-radius: var(--units-88, 88px);
          background: var(--states-minimal-alpha-8, rgba(255, 255, 255, 0.08));
          backdrop-filter: blur(20px);
          cursor: pointer;
        `
      : css``}
`
